import React from 'react';
import classnames from 'classnames';
import S from './TRLoader.css';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function TRLoader(props) {
  const {
    spinning
  } = props;
  return /*#__PURE__*/_jsxs("div", {
    className: S.loader,
    children: [spinning && /*#__PURE__*/_jsxs(React.Fragment, {
      children: [/*#__PURE__*/_jsx("div", {
        className: S.circle
      }), /*#__PURE__*/_jsx("div", {
        className: classnames(S.thumb, S.rotating)
      })]
    }), /*#__PURE__*/_jsx("img", {
      className: S.image,
      src: "https://recovr-ui-assets.storage.googleapis.com/progress-shield.png",
      alt: "Loading"
    })]
  });
}